// @flow
import React from "react";
import {reisy, use} from "reisy";
import DropdownItem from "./dropdown.js";
import {Button} from "./items.js";
import * as Icons from "../components/icons.js";

const styles = reisy`
@namespace User;

Button {
	width: 20px;
	height: 24px;
	padding: 8px 10px;
}

Avatar {
	width: 24px;
	border-radius: 20px;
	background-size: cover;
}

/* TODO: move the styles over here */
`;

const User = ({user}: {user: any}) => (
	user
	? <DropdownItem
		item="user"
		button={
			<Button style={user.avatar ? [styles.Avatar, {backgroundImage: `url(${user.avatar})`}] : styles.Button}>
				{user.avatar
					? <div />
					: <Icons.User />}
			</Button>}>
		<ul {...use(styles.List/*, isMobile && styles.MobileList*/)}>
			{Object.keys(user.urls).map(name => (
				<li key={name} {...use(styles.Item/*, isMobile && styles.MobileItem*/)}>
					<a href={user.urls[name][1]}>{user.urls[name][0]}</a>
				</li>
			))}
		</ul>
	</DropdownItem>
	: null
);

export default User;



// WEBPACK FOOTER //
// ./lib/navigation/user.js